import React, { useState } from 'react'
import DebateChat from '../../../DebateChat'
import { userInfo } from '../../../../../redux/Selectors/selectors';
import { useSelector } from 'react-redux';
import { changeArrayItemState, resetActions } from '../../../../common/show_and_hide';
import { Link } from 'react-router-dom';
import SuggestionForm from '.././SuggestionForm';
import FactCheckForm from './FactCheckForm';

const FactCheck = ({data}) => {

  const currentLoggedInUser = useSelector(userInfo)
  const opinions = data?.nodes || []

  const [editOpinions, setEditOpinions] = useState(Array.from({ length: opinions.length }, () => false));

  function toggleSuggestionSection(index) {
    if (editOpinions[index] === false) {
      resetActions(index, editOpinions, setEditOpinions)
    } else {
      changeArrayItemState(index, editOpinions, setEditOpinions)
    }
  }



  return (
    <section className='p-1 md:p-4'>
      <div>
        <h1 className='font-bold font-nunito text-base md:text-2xl'>Fact Check</h1>
      </div>



      <div className='h-[80vh] overflow-y-scroll scroll-bar-in-dark my-5'>

        {Array.isArray(opinions) && opinions.length > 0 ?
          (<div>
            {opinions.map((item, idx) => {

              const text = <div className=''>
                <p className='mb-4'>{item?.data?.claim}</p>
                {item?.data?.evidence?.startsWith("https")
                  ?
                  <Link
                    to={item?.data?.evidence}
                    className='underline text-blue-600 mb-2'
                  >
                    {item?.data?.evidence}</Link>
                  :
                  <p className='mb-2'>{item?.data?.evidence}</p>
                }
              </div>


              return (
                <div
                  key={idx}
                  onClick={() => {
                    toggleSuggestionSection(idx)
                  }}
                  className={`flex flex-col p-3 cursor-pointer`}>
                  <DebateChat
                    name={(item?.data?.user === currentLoggedInUser?.name) ? "You" : item?.data?.user}
                    stance={text}
                    containerClass='w-3/4'
                  />

                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}>
                    {editOpinions[idx] &&
                    <div>
                      {item?.data?.user === currentLoggedInUser?.name ?
                        <SuggestionForm
                        isMe={true}
                        data={item}
                        closeForm={() => {
                          toggleSuggestionSection(idx)
                        }} />
                      :

                      <FactCheckForm 
                        data={item}
                        closeForm={() => {
                          toggleSuggestionSection(idx)
                        }}
                      />

                      }
                    </div>
                    }
                  </div>
                  <hr />
                </div>

              )
            })}
          </div>
          )

          :

          <p className='text-center my-8'>No Argument.</p>
        }



      </div>

    </section>
  )
}

export default FactCheck